module.exports = __webpack_public_path__ + "img/tws11.043c2b3f.png";